import { CSSProperties, ElementType, HTMLAttributes } from 'react';

import { Container } from './styles';

export type IconProps = HTMLAttributes<HTMLDivElement> & {
  component: ElementType;
  fill?: string;
  size?: number;
  className?: string;
  color?: string;
  marginLeft?: string;
  marginRight?: string;
  event?: CSSProperties['pointerEvents'];
  cursor?: CSSProperties['cursor'];
};

export default function Icon({
  size = 24,
  fill = 'gray1',
  color,
  className,
  component: Component,
  marginLeft = '0px',
  marginRight = '0px',
  event = 'auto',
  cursor = 'pointer',
  ...rest
}: IconProps) {
  return (
    <Container
      className={className ?? ''}
      color={fill}
      $marginLeft={marginLeft}
      $marginRight={marginRight}
      $event={event}
      $cursor={cursor}
      {...rest}
    >
      <Component color={color ? color : ''} width={size} height={size} />
    </Container>
  );
}
